import { useEffect } from "react";

const DRAWING_SHORTCUT_PATHS = [
  "/cadastro_novo_pasto",
  "/cadastro_nova_fazenda",
  "/nova_fazenda",
];

function isTypingTarget(target: EventTarget | null) {
  if (!(target instanceof HTMLElement)) {
    return false;
  }

  const tagName = target.tagName.toLowerCase();
  return (
    target.isContentEditable ||
    tagName === "input" ||
    tagName === "textarea" ||
    tagName === "select"
  );
}

type UseDrawingKeyboardShortcutsParams = {
  disableDrawing: () => void;
  enableDrawing: () => void;
};

export function useDrawingKeyboardShortcuts({
  disableDrawing,
  enableDrawing,
}: UseDrawingKeyboardShortcutsParams) {
  useEffect(() => {
    const handleDrawingShortcut = (event: KeyboardEvent) => {
      if (!DRAWING_SHORTCUT_PATHS.includes(window.location.pathname)) {
        return;
      }

      if (event.key === "Escape") {
        disableDrawing();
        return;
      }

      if (event.key.toLowerCase() === "p" && !isTypingTarget(event.target)) {
        enableDrawing();
      }
    };

    document.addEventListener("keydown", handleDrawingShortcut, false);

    return () => {
      document.removeEventListener("keydown", handleDrawingShortcut, false);
    };
  }, [disableDrawing, enableDrawing]);
}
